<template>
  <div>
    <template v-if="loginError">
      <p role="alert">{{ loginError }}</p>
      <router-link :to="{name: 'login'}">Zur Anmeldung</router-link>
    </template>
    <p v-else role="status">Login wird geprüft.</p>
  </div>
</template>

<script>
import {useCallbackStore} from '../../stores/callback';
import {useUserStore} from '../../stores/user';

export default {
  setup() {
    return {callbackStore: useCallbackStore(), userStore: useUserStore()}
  },
  data() {
    return {loginError: ''}
  },
  async created() {
    const {code, state} = this.$route.query
    const provider = this.$route.params.provider
    // Remove the one-use code from history before doing network requests.
    this.$router.replace({query: {}})
    try {
      const {data} = await this.callbackStore.callback(provider, code, state)
      if (data.error || !data.token) {
        throw new Error('Die Anmeldung ist fehlgeschlagen.')
      }
      await this.userStore.loginSuccessful(data.token)
    } catch (error) {
      this.loginError = error?.response?.data?.message || error.message || 'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.'
    }
  },
}
</script>
